import { render, staticRenderFns } from "./associationSelector.vue?vue&type=template&id=fa7a9f36&scoped=true&"
import script from "./associationSelector.vue?vue&type=script&lang=js&"
export * from "./associationSelector.vue?vue&type=script&lang=js&"
import style0 from "./associationSelector.vue?vue&type=style&index=0&id=fa7a9f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7a9f36",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QImg,QMenu});
